<template>
  <ul class="px-[10px]">
    <ChainCard
      v-for="value in filteredTransactions(chains).items"
      :key="value.id"
      :chain="value" />
    <div v-if="chains.total > maxResults" class="flex justify-end mt-[5px]">
      <a
        @click="loadMoreResults"
        class="max-w-fit-content px-4 py-2 text-blue-dark font-jost-semibold text-right rounded-lg hover:bg-blue-700 transition-colors duration-200 block cursor-pointer">
        Show more
      </a>
    </div>
  </ul>
</template>

<script>
import { filteredTransactions } from '@/helpers/common';
import { MAX_SEARCH_RESULTS } from '@/helpers/constants';
import ChainCard from '@/components/common/ChainCard.vue';
import { UiTypes } from '@/utils/uiTypes';

export default {
  name: 'ChainsList',
  components: {
    ChainCard,
  },
  props: {
    chains: {
      type: Object,
      default: () => ({ items: [] })
    }
  },
  data() {
    return {
      uiTypes: UiTypes,
      maxResults: MAX_SEARCH_RESULTS,
    };
  },
  methods: {
    filteredTransactions(list) {
      return filteredTransactions(list);
    },
    loadMoreResults() {
      // Navigate to AllResults page with chains type
      this.$router.push({
        name: 'resultsByType',
        params: { type: this.uiTypes.chain },
        query: this.$route.query
      });
    }
  }
}
</script>

<style scoped>
/* Component styles are handled by Tailwind classes */
</style>
